import React from "react";

const LibrarySong = ({
  song,
  songs,
  setCurrentSong,
  currentSong,
  id,
  setSongs,
  isPlaying,
  setIsPlaying,
  setIsLibraryOpen,
}) => {
  const songSelectHandler = async () => {
    await setCurrentSong(song);
    setIsPlaying(true);
    setSongs(
      songs.map((targetSong) => {
        return {
          ...targetSong,
          active: targetSong.id === song.id,
        };
      })
    );
    setIsLibraryOpen(false);
  };
  return (
    <div
      onClick={songSelectHandler}
      className={`library-song ${
        song.id === currentSong.id ? "selected" : ""
      } `}
    >
      <img src={song.cover} alt={song.name} />
      <div className="song-description">
        <h3>{song.name}</h3>
        <h4>{song.artist}</h4>
      </div>
    </div>
  );
};

export default LibrarySong;
